import React, { ForwardedRef, useContext } from 'react';
import { OriginIconProps } from '../type';
import { Context } from '../context';

function IconInfoSolidComponent(props: OriginIconProps, ref: ForwardedRef<SVGSVGElement>) {
    const { prefix: prefixFromContext } = useContext(Context);
    const { className = '', prefix: prefixFromProps, width = '1em', height = '1em', useCurrentColor = true, spin, ...rest } = props;

    const prefix = prefixFromProps || prefixFromContext || 'alliance';
    const loadingKls = spin ? ` ${prefix}-icon-loading` : '';
    return <svg className={`${prefix}-icon ${prefix}-icon-InfoSolid${loadingKls} ${className}`} width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest} ref={ref}><circle cx="24" cy="24" r="21" fill={useCurrentColor ? 'currentColor' : '#369AFE'}/><path fillRule="evenodd" clipRule="evenodd" d="M24 17C25.1046 17 26 16.1046 26 15C26 13.8954 25.1046 13 24 13C22.8954 13 22 13.8954 22 15C22 16.1046 22.8954 17 24 17ZM24 19C22.8954 19 22 19.8954 22 21V33C22 34.1046 22.8954 35 24 35C25.1046 35 26 34.1046 26 33V21C26 19.8954 25.1046 19 24 19Z" fill={useCurrentColor ? 'currentColor' : '#fff'}/></svg>;
}

const IconInfoSolid = React.forwardRef(IconInfoSolidComponent);
export default IconInfoSolid;
